import React, { useState } from 'react';
import SeoHead from '../components/SeoHead';
import { getOptimizedImageUrl } from '../lib/cms';

export default function ForedragPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const foredragList = [
    {
      title: 'Tegneterapi',
      tag: 'Workshop & Kursus',
      icon: 'fa-palette',
      content: (
        <div className="space-y-3">
          <p>
            Det er mere en workshop end et foredrag, hvor du selv skal være aktiv udøver. Vi arbejder med symboler og farver, individuelt og i grupper. Gennem tegneterapien og de værktøjer, der ligger i forløbet, opstår der tydelige billeder/indsigter om dig selv og din omverden.
          </p>
          <p>
            Jeg har arbejdet i grupper med tegneterapi som fortløbende kursus, så jeg har mange input til at arbejde med både symboler og selve processen. Du behøver ikke "at kunne tegne" for at deltage. Foredraget kan ændres til et kursus, alt efter varighed og interesser.
          </p>
        </div>
      )
    },
    {
      title: 'Eventyrvisdom for maskulin og feminin udvikling',
      tag: 'Livsrejser & Arketyper',
      icon: 'fa-crown',
      content: (
        <div className="space-y-4">
          <p className="font-serif italic text-[#d9238c]">
            Den virkelige visdom ligger gemt i de gamle folkeeventyr, som jeg skrev hovedopgave i på seminariet i Dansk.
          </p>
          
          <div className="bg-[#faf5f9] p-5 rounded-2xl border border-[#edd5e8] space-y-2">
            <h4 className="font-serif font-bold text-[#1f142e] text-base">FEMININ REJSE:</h4>
            <p>
              Det er en meget spændende rejse ind i essensen af det feminine – mest udgangspunkt i eventyret Askepot. Der findes et udtryk: Askepotkomplekset. Det er, når kvinder integrerer stedmor og stedsøstre ind i sit system og agerer ud fra det – og ikke fra sit eget indre. I Grimms udgave af folkeeventyret ligger der en masse visdom gemt, som vi kan bruge og lære af, som kan ændre den måde, vi ser vores liv på. Askepot fortæller os i eventyret, hvordan kvinder kan frigøre sig fra de bånd, vi bliver pålagt, og finde ind til sig selv. Mænd er velkomne til at lytte med, der er meget at lære om kvinder.
            </p>
          </div>

          <div className="bg-[#faf5f9] p-5 rounded-2xl border border-[#edd5e8] space-y-2">
            <h4 className="font-serif font-bold text-[#1f142e] text-base">MASKULIN REJSE:</h4>
            <p>
              Gennem Grimms udgave af folkeeventyret Jern-Hans kommer vi helt tæt på, hvad det maskuline består af, og hvordan mænd finder frem til "guldet". Det er en dyb rejse med mange aspekter af en ung mands livsrejse og alle de genvordigheder, der kan være på sådan en rejse, for endelig at finde sit eget maskuline selv. Mange mænd kan virkelig gøre brug af at kende til de dybe maskuline værdier – og kvinder kan lære meget af at lytte med. På mit PD-studie skrev jeg hovedopgave i Maskulin udvikling af drenge i Folkeskolen, og det skabte en nysgerrighed i mig til at lære om det køn, jeg ikke selv er født ind i, og det var en helt ny verden, der åbnede sig for mig.
            </p>
          </div>

          <p className="text-xs text-[#9b1b66] italic">
            Disse 2 eventyrforedrag kan både være samlet eller delt i 2.
          </p>
        </div>
      )
    },
    {
      title: 'Wicca – moderne hekse i nyere tid',
      tag: 'Naturreligion & Magi',
      icon: 'fa-moon',
      content: (
        <div className="space-y-3">
          <p>
            Wicca er oldgammel viden, der er samlet i nyere tid i begrebet wicca. Fra tidligere tiders vølver opstod begrebet heks, som var en klog kone fyldt med visdom og urtekendskab mv., som var samfundets hjælper, når livet gjorde ondt, om det så var fysisk eller psykisk.
          </p>
          <p>
            I dag bruger vi wicca til at samle den gamle magiske viden for at kunne anvende de gamle redskaber til bl.a. selvudvikling og manifestationer. Du får viden om Årshjulet og forskellige magiske redskaber, og hvordan du selv kan arbejde med magien.
          </p>
        </div>
      )
    },
    {
      title: 'Jul fra førkristen tid',
      tag: 'Jól, Yule & Tradition',
      icon: 'fa-sun',
      content: (
        <div className="space-y-3">
          <p className="font-medium text-[#1f142e]">
            Fortællinger om førkristen jul og eksempel på sabbat i naturreligioners årshjul.
          </p>
          <p>
            Foredrag om vikingernes Jól og eksempel fra wicca-troens Yule, som begge danner baggrund for den førkristne fejring af lysets komme. Kom og hør om, hvordan vikingerne drak Jól, og hvordan kristendommen forsøgte at bekæmpe de gamle traditioner, først ved magt, og senere ved list.
          </p>
          <p className="font-serif italic text-[#d9238c]">
            Hør, hvordan Yule fejres for hekse og godtfolk i dag!
          </p>
        </div>
      )
    },
    {
      title: 'Træer – og dit forhold til dem',
      tag: 'Naturvisdom & Månetræer',
      icon: 'fa-tree',
      content: (
        <div className="space-y-3">
          <p>
            Du går sikkert tit forbi dem – måske uden at give dem særlig opmærksomhed. Træernes væsen er dog langt mere værd at vise interesse for. Jeg vil fortælle om Modertræer, og hvordan de passer på deres "afkom" og andre træer omkring sig.
          </p>
          <p>
            Der er masser af viden om træer, og hvordan du kan bruge deres energier til fx at falde helt til ro op ad en stamme, hvordan du kan mærke deres energier og meget mere. Der vil samtidig også blive oplæsning fra min bog Månetræer.
          </p>
          <p className="font-medium text-[#d9238c]">
            Er du nysgerrig på træernes virkning på os mennesker? Så er dette det rette foredrag for dig.
          </p>
        </div>
      )
    },
    {
      title: 'Breathwork – det gælder livet',
      tag: 'Aktivt foredrag',
      icon: 'fa-wind',
      content: (
        <div className="space-y-3">
          <p>
            Under dette aktive foredrag vil du lære om vejrtrækning, som kan ændre dit liv. Du vil lære om nye tilstande i kroppen ved at trække vejret på helt specifikke måder, og du vil mærke forskel på de forskellige vejrtrækningsmetoder.
          </p>
          <p>
            At trække vejret lyder helt basalt, men der er i virkeligheden mange måder at trække vejret på, og de har hver deres virkninger på kroppen og psyken – og helbredet.
          </p>
          <p>
            Vi får generelt alt for lidt ilt til vores muskler, fordi vi er vant til at passe på os selv, frygte verden omkring os, altid være parat til at forsvare os, enten fysisk eller nok mest verbalt, og det betyder en hæmmet vejrtrækning og dermed for lidt ilt til krop og hjerne.
          </p>
          <p className="font-semibold text-[#1f142e]">
            Mærk forskellen under dette foredrag og lær, hvordan du kan forbedre dit liv.
          </p>
        </div>
      )
    },
    {
      title: 'Hvad er magi?',
      tag: 'Energi & Praksis',
      icon: 'fa-wand-magic-sparkles',
      content: (
        <div className="space-y-3">
          <p>
            Her vil vi se på følgende emner inden for den magiske verden:
          </p>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm text-[#4e3568] pt-1">
            <li className="flex items-center gap-2">
              <i className="fa-solid fa-sparkles text-[11px] text-[#d9238c]"></i>
              <span>Essentiel magi – transformation fra en tilstand til en anden</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="fa-solid fa-sparkles text-[11px] text-[#d9238c]"></i>
              <span>Hverdagsmagi</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="fa-solid fa-sparkles text-[11px] text-[#d9238c]"></i>
              <span>Fornemmelse af energi</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="fa-solid fa-sparkles text-[11px] text-[#d9238c]"></i>
              <span>Spells – besværgelser</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="fa-solid fa-sparkles text-[11px] text-[#d9238c]"></i>
              <span>Psykisk magi – ændre dit humør eller din tilstand</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="fa-solid fa-sparkles text-[11px] text-[#d9238c]"></i>
              <span>Spirituel magi – manifestere højere vibrationer</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="fa-solid fa-sparkles text-[11px] text-[#d9238c]"></i>
              <span>Loven om tiltrækning</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="fa-solid fa-sparkles text-[11px] text-[#d9238c]"></i>
              <span>Arbejde med magi som shaman</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="fa-solid fa-sparkles text-[11px] text-[#d9238c]"></i>
              <span>Lave beskyttende cirkler</span>
            </li>
            <li className="flex items-center gap-2">
              <i className="fa-solid fa-sparkles text-[11px] text-[#d9238c]"></i>
              <span>Healing & Transformere tilstande</span>
            </li>
            <li className="flex items-center gap-2 sm:col-span-2">
              <i className="fa-solid fa-sparkles text-[11px] text-[#d9238c]"></i>
              <span>Arbejde magisk med genstande fx planter, røg (renselse) eller krystaller</span>
            </li>
          </ul>
          <p className="font-semibold text-[#1f142e] pt-2">
            Lyst til at arbejde med magi, så er dette et godt foredrag at begynde med eller videreudvikle på.
          </p>
        </div>
      )
    },
    {
      title: 'Slangeæg og dragekraft – om symboler fra vores underbevidsthed',
      tag: 'Trommerejse & Urkraft',
      icon: 'fa-drum',
      content: (
        <div className="space-y-3">
          <p>
            En magisk trommerejse ind i dig selv. Gennem trommens lyd, som er Moder Jords hjertelyd, kommer du ind i dit inderste sind, hvorfra urkræfterne kan fortælle dig om dit dybereliggende jeg, her forklædt som din indre drage- eller slangekraft.
          </p>
          <p>
            Kom og hør om grundliggende symboler fra vores underbevidsthed og prøv kræfter med dem under en trommerejse, hvor du kan møde dragen eller slangen som et af dine indre kraftdyr og din urkraft.
          </p>
          <p>
            Jeg fortæller om nogle af de mest dybtliggende symboler, som vi kollektivt anvender fra det ubevidste i vores drømme og mere bevidst som kraftsymboler.
          </p>
          <p>
            Jeg guider herefter en trommerejse, hvor du har mulighed for kontakt med nogle af disse fantastiske kraftvæsener, hvorefter vi debatterer oplevelser og visdom.
          </p>
        </div>
      )
    }
  ];

  return (
    <>
      <SeoHead
        title="Foredrag med Lone Hvid – Visdom, symboler og magi | Ibjerget"
        description="Foredrag og workshops med Lone Hvid på Ibjerget eller hos jer: Tegneterapi, Eventyrvisdom, Wicca, Breathwork, Magi, Træer og Trommerejser."
        canonicalUrl="https://www.ibjerget.dk/foredrag"
      />

      {/* Hero */}
      <section className="relative pt-32 pb-20 sm:pt-40 sm:pb-28 bg-[#381d6e] text-white overflow-hidden">
        <div className="absolute inset-0 z-0 opacity-25">
          <img
            src={getOptimizedImageUrl('https://assets.auxodev.dk/assets/1df9f3fb-cd3d-49d9-8f1a-8a59416f1b4e/lone-foredrag.webp', { width: 1400, quality: 80, fit: 'cover' })}
            alt="Lone Hvid ved flipover om Wicca og naturreligion"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-t from-[#381d6e] via-[#381d6e]/75 to-transparent" />

        <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-[#d9238c]/30 border border-[#d9238c]/40 text-[#f7eefa] text-xs font-semibold uppercase tracking-wider mb-6">
            <i className="fa-solid fa-microphone-lines" aria-hidden="true"></i>
            <span>Foredrag & Workshops v. Lone Hvid</span>
          </span>
          <h1 className="font-serif text-4xl sm:text-5xl md:text-6xl font-bold text-[#faf5f9] tracking-tight leading-tight">
            Foredrag
          </h1>
          <p className="mt-6 text-base sm:text-xl text-[#f7eefa] max-w-2xl mx-auto leading-relaxed font-normal">
            En blanding af viden, visdom og livserfaring om symboler, eventyr, naturreligion og bevidsthed.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <a
              href="#oversigt"
              className="px-8 py-4 rounded-full bg-[#d9238c] hover:bg-[#be1878] text-white font-semibold text-sm shadow-md transition-colors"
            >
              Se emnerne
            </a>
            <a
              href="#booking"
              className="px-8 py-4 rounded-full bg-white/10 hover:bg-white/20 text-white font-semibold text-sm border border-white/20 transition-colors"
            >
              Praktisk info & Booking
            </a>
          </div>
        </div>
      </section>

      {/* Intro med lone-foredrag.webp */}
      <section className="py-20 sm:py-24 bg-[#faf5f9]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            
            <div className="lg:col-span-5 flex justify-center">
              <div className="rounded-3xl overflow-hidden shadow-xl border border-[#edd5e8] bg-white max-w-md w-full">
                <img
                  src={getOptimizedImageUrl('https://assets.auxodev.dk/assets/1df9f3fb-cd3d-49d9-8f1a-8a59416f1b4e/lone-foredrag.webp', { width: 800, quality: 85, fit: 'cover' })}
                  alt="Lone stående ved en flipover med teksten Wicca – en natur religion"
                  className="w-full h-auto object-cover"
                />
                <div className="p-4 bg-[#fcf8fb] text-xs text-[#9b1b66] text-center border-t border-[#edd5e8]">
                  Lone Hvid underviser og holder foredrag om naturreligion, symboler og personlig udvikling
                </div>
              </div>
            </div>

            <div className="lg:col-span-7 space-y-6">
              <span className="text-xs font-semibold uppercase tracking-widest text-[#d9238c] block">
                Baggrund & Filosofi
              </span>
              <h2 className="font-serif text-3xl sm:text-4xl font-semibold text-[#1f142e] tracking-tight">
                Viden og visdom gennem et helt liv
              </h2>

              <div className="prose prose-stone text-[#4e3568] text-base leading-relaxed space-y-4">
                <p>
                  Min baggrund for disse foredrag er mange uddannelser og mange års livserfaringer, hvor jeg altid har været nysgerrig på livets mange facetter. Jeg er uddannet lærer og voksenunderviser. Jeg har en PD i psykologi og mange andre uddannelser, men vigtigst her er en blanding af viden og visdom, jeg har opsamlet i løbet af mit liv.
                </p>
                <p>
                  Jeg har været lærer i mange år med specialer i dansk og billedkunst. Jeg har mange små kurser inden for symboler og selvudvikling og har selv udgivet 2 bøger, Præstindens Vej og Månetræer, samt en e-bog (endnu ikke udgivet) Portaler til Spirituelle Verdener.
                </p>
              </div>

              <div className="pt-2 flex items-center gap-4 text-xs sm:text-sm text-[#9b1b66] font-medium">
                <span className="flex items-center gap-1.5">
                  <i className="fa-solid fa-check text-[#d9238c]"></i>
                  Lærer & Voksenunderviser
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="fa-solid fa-check text-[#d9238c]"></i>
                  PD i psykologi
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="fa-solid fa-check text-[#d9238c]"></i>
                  Forfatter & Shaman
                </span>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* Foredrags-oversigt */}
      <section id="oversigt" className="py-20 sm:py-24 bg-white border-t border-[#edd5e8] scroll-mt-20">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 space-y-12">
          
          <div className="text-center max-w-2xl mx-auto space-y-3">
            <span className="text-xs font-semibold uppercase tracking-widest text-[#d9238c] block">
              Foredragsrækken
            </span>
            <h2 className="font-serif text-3xl sm:text-4xl font-semibold text-[#1f142e]">
              Oversigt over foredrag & workshops
            </h2>
            <p className="text-sm text-[#4e3568]">
              Klik på de enkelte foredrag herunder for at læse om indholdet og forløbet.
            </p>
          </div>

          <div className="space-y-4">
            {foredragList.map((f, idx) => {
              const isOpen = openIndex === idx;
              return (
                <div
                  key={idx}
                  className="rounded-2xl border border-[#edd5e8] overflow-hidden transition-all duration-200 bg-[#fcf8fb]"
                >
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : idx)}
                    className="w-full text-left p-6 sm:p-7 flex items-center justify-between gap-4 hover:bg-[#faf5f9] transition-colors"
                    aria-expanded={isOpen}
                  >
                    <div className="flex items-center gap-4 min-w-0">
                      <div className="w-10 h-10 rounded-xl bg-[#d9238c]/15 text-[#d9238c] flex items-center justify-center shrink-0">
                        <i className={`fa-solid ${f.icon} text-base`}></i>
                      </div>
                      <div className="min-w-0">
                        <span className="text-[11px] uppercase tracking-wider text-[#d9238c] font-semibold block">
                          {f.tag}
                        </span>
                        <h3 className="font-serif text-lg sm:text-xl font-semibold text-[#1f142e] leading-snug">
                          {f.title}
                        </h3>
                      </div>
                    </div>
                    <div className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 border border-[#edd5e8] text-[#9b1b66] transition-transform duration-200 ${isOpen ? 'rotate-180 bg-[#d9238c] text-white' : 'bg-white'}`}>
                      <i className="fa-solid fa-chevron-down text-xs"></i>
                    </div>
                  </button>

                  {isOpen && (
                    <div className="px-6 pb-7 pt-2 text-[#4e3568] text-sm sm:text-base border-t border-[#edd5e8] bg-white">
                      {f.content}
                    </div>
                  )}
                </div>
              );
            })}
          </div>

          {/* Særlige ønsker / Andre foredrag */}
          <div className="p-8 rounded-3xl bg-[#faf5f9] border border-[#edd5e8] text-center space-y-4">
            <h3 className="font-serif text-xl sm:text-2xl font-semibold text-[#1f142e]">
              Har du brug for andre foredrag inden for spiritualitet eller selvudvikling?
            </h3>
            <p className="text-sm text-[#4e3568] max-w-xl mx-auto">
              Kontakt mig gerne, hvis I har særlige ønsker eller temaer til jeres forening, arbejdsplads, coven eller interessegruppe.
            </p>
            <a
              href="mailto:lone.hvid@hotmail.com"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#d9238c] hover:bg-[#be1878] text-white font-semibold text-sm shadow transition-colors"
            >
              <i className="fa-regular fa-envelope"></i>
              <span>Kontakt Lone om foredrag</span>
            </a>
          </div>

        </div>
      </section>

      {/* Praktisk information */}
      <section id="booking" className="py-20 sm:py-24 bg-[#381d6e] text-white scroll-mt-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          
          <div className="text-center space-y-3">
            <span className="text-xs font-semibold uppercase tracking-widest text-[#e895c8] block">
              Priser & Betingelser
            </span>
            <h2 className="font-serif text-3xl sm:text-4xl font-semibold text-[#faf5f9]">
              Praktisk information for foredrag
            </h2>
          </div>

          <div className="bg-[#4a2282] rounded-3xl p-8 sm:p-10 border border-[#5f2a99] shadow-xl space-y-6">
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pb-6 border-b border-[#5f2a99]">
              <div>
                <span className="text-xs uppercase tracking-wider text-[#e895c8] font-semibold block mb-1">
                  Pris foredrag
                </span>
                <span className="font-serif text-3xl font-bold text-white">
                  1.000 kr.
                </span>
              </div>
              <div>
                <span className="text-xs uppercase tracking-wider text-[#e895c8] font-semibold block mb-1">
                  Varighed
                </span>
                <span className="text-base text-[#f7eefa]">
                  1-2 timer – spørg. Det kan tilrettes.
                </span>
              </div>
            </div>

            <div className="space-y-3 text-sm text-[#f7eefa]">
              <div className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-[#e895c8] mt-1 shrink-0"></i>
                <p>
                  <strong>Sted på Ibjerget:</strong> Ibjergvej 12, 5792 Årslev – max 30 personer (kaffe/te inkluderet).
                </p>
              </div>
              <div className="flex items-start gap-3">
                <i className="fa-solid fa-car text-[#e895c8] mt-1 shrink-0"></i>
                <p>
                  <strong>Foredrag andre steder:</strong> 1.000 kr. + 4 kr. pr. kørt kilometer + evt. brotakst.
                </p>
              </div>
            </div>

            <div className="pt-4 border-t border-[#5f2a99] space-y-4 text-center">
              <p className="text-sm text-[#f7eefa]">
                Kontakt Lone Hvid direkte for booking af foredrag og forespørgsler:
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <a
                  href="tel:30297902"
                  className="px-8 py-4 rounded-full bg-[#d9238c] hover:bg-[#be1878] text-white font-semibold text-sm shadow transition-colors flex items-center gap-2"
                >
                  <i className="fa-solid fa-phone"></i>
                  <span>Ring på 30 29 79 02</span>
                </a>
                <a
                  href="mailto:lone.hvid@hotmail.com"
                  className="px-8 py-4 rounded-full bg-white/10 hover:bg-white/20 text-white font-semibold text-sm border border-white/20 transition-colors flex items-center gap-2"
                >
                  <i className="fa-regular fa-envelope"></i>
                  <span>Send mail til Lone</span>
                </a>
              </div>
            </div>

          </div>

        </div>
      </section>
    </>
  );
}
